function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M8.56 3.34v14.33c-.34.01-.68.09-.93.24l-2.35 1.34c-1.64.94-2.99.16-2.99-1.74V7.78c0-.63.45-1.41 1.01-1.73l4.33-2.48c.25-.14.59-.22.93-.23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.73 6.33v14.33c-.35.01-.69-.05-.96-.18l-5.25-2.63c-.27-.13-.61-.19-.96-.18V3.34c.35-.01.69.05.96.18l5.25 2.63c.27.13.61.19.96.18z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 6.49v9.73c0 .63-.45 1.41-1.01 1.73l-4.33 2.48c-.25.14-.59.22-.93.23V6.33c.34-.01.68-.09.93-.24l2.35-1.34C20.65 3.81 22 4.59 22 6.49z"
})));